import { useEffect } from 'react';
import useAppState from '../../AppStore';
import { useTracking } from './TrackingContext';

const TrackInitialLayers = () => {
  const { Tracking } = useTracking();
  const errorLayers = useAppState((state) => state.errorLayers);
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);
  const selectedBasemapId = useAppState((state) => state.selectedBasemapId);

  // Tracke geladene topics beim Start des Viewers
  useEffect(() => {
    selectedTopicLayers.forEach((topicId: string) => {
      Tracking.Topics.addTopic(
        topicId,
        selectedTopicLayers.length + 1,
        'topics',
        'start',
      );
    });

    // Tracke loading Error beim Start
    errorLayers.forEach((topicId: string) => {
      if (selectedTopicLayers.includes(topicId) && topicId !== selectedTopicLayers[0]) {
        // erstes Topic wird hier nicht getrack sondern in TopicLayers.tsx
        Tracking.Error.topicLoadingError(topicId);
      }
    });

    // Tracke basemap beim Laden des Viewers
    Tracking.Basemap.addBasemap(selectedBasemapId);
  }, []);

  return null;
};

export default TrackInitialLayers;
